import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSelectedDevices } from './useSelectedDevices';

export const useUpdateParent = () => {
  const parentOrigin = useSelector((s) => s.scenario.parentOrigin);
  const { hideVideo, muted } = useSelector((s) => s.device);
  const selectedDevices = useSelectedDevices();

  useEffect(() => {
    if (!parentOrigin) return;

    window.parent.postMessage(
      {
        type: 'settingsChanged',
        payload: {
          devices: selectedDevices,
          startAsMuted: muted,
          startAsHidden: hideVideo,
        },
      },
      parentOrigin
    );
  }, [parentOrigin, selectedDevices, muted, hideVideo]);
};
